import {
    Paper,
    Typography,
    Grid,
    Container,
    TableContainer,
  } from '@material-ui/core'

  import {
    PieChart,
    Pie,
    Sector,
    Cell,
    BarChart,
    Bar,
    LineChart,
    Line,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    Legend,
    ResponsiveContainer,
  } from 'recharts'

export default function GraficoHoras({empAvulsas}) {
    return(
    <Grid item xs={12} sm={12}>
        <Container component={Paper} maxWidth="xl">
        <br />
        <ResponsiveContainer width="100%" height={500}>
          <BarChart
            data={empAvulsas}
            margin={{
              top: 20,
              right: 30,
              left: 20,
              bottom: 5,
            }}
          >
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="name" />
            <YAxis />
            <Tooltip />
            <Legend />
            <Bar dataKey="pacote_horas" stackId="a" fill="#0096c7" />
          </BarChart>
        </ResponsiveContainer>
      </Container>
    </Grid>
    );
}